"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _index = require("@/api/college/index");
var _common = require("@/api/common");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: {
      type: Number,
      default: 0
    },
    majorName: {
      type: String,
      default: ''
    },
    courseName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      major: [],
      majorList: [{
        majorName: '全部'
      }, {
        majorName: '农林牧渔'
      }, {
        majorName: '装备制造'
      }, {
        majorName: '电子与信息'
      }, {
        majorName: '资源环境与安全'
      }, {
        majorName: '能源动力与材料'
      }, {
        majorName: '生物与化工'
      }, {
        majorName: '交通运输'
      }, {
        majorName: '财经商贸'
      }, {
        majorName: '土木建筑'
      }, {
        majorName: '水利'
      }, {
        majorName: '轻工纺织'
      }, {
        majorName: '食品药品与粮食'
      }, {
        majorName: '医药卫生'
      }, {
        majorName: '旅游'
      }, {
        majorName: '文化艺术'
      }, {
        majorName: '新闻传播'
      }, {
        majorName: '教育与体育'
      }, {
        majorName: '公安与司法'
      }, {
        majorName: '公共管理与服务'
      }, {
        majorName: '公共基础与通识教育'
      }],
      // majorList: this.$store.getters.wIndustryCategory,
      searchForm: {
        majorName: '',
        courseName: ''
      }
    };
  },
  watch: {
    majorName: {
      handler: function handler(value) {
        this.searchForm.majorName = value || "";
      },
      immediate: true
    },
    courseName: {
      handler: function handler(value) {
        this.searchForm.courseName = value || "";
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;
    // console.log(this.majorList);
    // this.getcategoriesList()
    //获取专业大类
    (0, _common.getMajorList)({
      parentId: "0",
      type: 2,
      pageNum: 1,
      pageSize: 99999999
    }).then(function (res) {
      _this.major = res.rows;
      // 根据传入的majorName默认选中
      if (_this.majorName) {
        _this.searchForm.majorName = _this.majorName;
        _this.handleSearch();
      }
    });
  },
  methods: {
    //专业大类
    getcategoriesList: function getcategoriesList() {
      var _this2 = this;
      (0, _index.categoriesList)({
        pageNum: 1,
        pageSize: 99999,
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.majorList = res.data.list;
        }
      });
    },
    handleSearch: function handleSearch() {
      console.log('searchForm', this.searchForm);
      this.$emit('toSsearch', this.searchForm);
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["search_click", "CLK", {
          //以下为事件属性
          keyword: this.searchForm.majorName + ',' + this.searchForm.courseName
        }]
      });
    }
  }
};